import { render, staticRenderFns } from "./QuoteOtherLabour.vue?vue&type=template&id=74d68105&scoped=true"
import script from "./QuoteOtherLabour.vue?vue&type=script&lang=js"
export * from "./QuoteOtherLabour.vue?vue&type=script&lang=js"
import style0 from "./QuoteOtherLabour.vue?vue&type=style&index=0&id=74d68105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d68105",
  null
  
)

export default component.exports